import { FiInfoIconMode } from '@fi-shared/info-icon/info-icon.component';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-completed-after-deadline-badge',
    templateUrl: './completed-after-deadline-badge.component.html',
    styleUrls: ['./completed-after-deadline-badge.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-completed-after-deadline-badge' },
    standalone: false,
})
export class CompletedAfterDeadlineBadgeComponent {
    protected readonly FiInfoIconMode = FiInfoIconMode;
}
